import Modal from "../../modal/Modal";
import "./PlanManagerModal.scss";

/**
 * Plan Manager confirmation modal. Wraps the shared Modal with a title, body,
 * and one or two action buttons. Presentational — all behavior flows through
 * the supplied callbacks; owns no state.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {string} props.title
 * @param {string} props.body
 * @param {string} props.primaryText - Label for the primary (confirm) action.
 * @param {string} [props.secondaryText] - Label for the optional secondary action.
 * @param {() => void} props.onPrimary
 * @param {() => void} [props.onSecondary]
 * @param {() => void} [props.onClose] - Passed to Modal for backdrop/close control.
 * @param {"default" | "accent"} [props.tone="default"] - Accent stacks full-width pink actions.
 * @returns {import('react').JSX.Element}
 */
const PlanManagerModal = ({
    isOpen,
    title,
    body,
    primaryText,
    secondaryText,
    onPrimary,
    onSecondary,
    onClose,
    tone = "default",
}) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <div
            className={
                tone === "accent"
                    ? "plan-manager-modal plan-manager-modal--accent"
                    : "plan-manager-modal"
            }
        >
            <p className="plan-manager-modal__title">{title}</p>
            <p className="plan-manager-modal__body">{body}</p>
            <div className="plan-manager-modal__actions">
                <button
                    type="button"
                    className="plan-manager-modal__primary"
                    onClick={onPrimary}
                >
                    {primaryText}
                </button>
                {secondaryText ? (
                    <button
                        type="button"
                        className="plan-manager-modal__secondary"
                        onClick={onSecondary}
                    >
                        {secondaryText}
                    </button>
                ) : null}
            </div>
        </div>
    </Modal>
);

export default PlanManagerModal;
